import { formatNumber } from '../../../core/helpers';
import './FeesItem.scss';

export interface Fee {
  name: string;
  amount: number;
  value: number;
}

interface Props {
  item: Fee;
  className?: string;
}

export default function FeesItem({
  item: { name, amount, value },
  className = '',
}: Props) {
  return (
    <div
      className={`d-flex align-items-center justify-content-between ${className}`}
    >
      <div className='fw-600'>{name}</div>
      <div className='d-flex align-items-center'>
        <div className='fw-600 pe-3'>
          <span className='Text--green'>
            {formatNumber(amount / 100, {
              currency: 'eur',
            })}
          </span>
          <span className={value > amount ? 'Text--orange' : 'Text--gray'}>
            &nbsp;/&nbsp;
            {formatNumber(value / 100, {
              currency: 'eur',
            })}
          </span>
        </div>
        <div
          className='ms-n1 d-flex align-items-center'
          style={{
            width: 160,
          }}
        >
          <div
            className='FeesItem__indicator'
            style={{
              width: `${Math.round((amount / (amount + value)) * 100)}%`,
            }}
          />
          <div
            className={
              value > amount
                ? 'FeesItem__indicator--orange'
                : 'FeesItem__indicator--gray'
            }
            style={{
              width: `${Math.round((value / (amount + value)) * 100)}%`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
